import { render, staticRenderFns } from "./topCarousel.vue?vue&type=template&id=1b228563&scoped=true"
import script from "./topCarousel.vue?vue&type=script&lang=js"
export * from "./topCarousel.vue?vue&type=script&lang=js"
import style0 from "./topCarousel.vue?vue&type=style&index=0&id=1b228563&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b228563",
  null
  
)

export default component.exports